import { useCallback, useEffect, useState } from 'react';
import {
  Button,
  Container,
  Dialog,
  Divider,
  Grid,
  IconButton,
  Paper,
  Stack,
  Typography,
  Checkbox,
  Box,
  TextField as MuiTextField
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { FormProvider, Table, TextField, SelectTag } from '../../../../../../components';
import { useRef } from 'react';
import {
  dropdownFetch,
  getCityByState,
  getKeyPathValue,
  getStatesByCountry,
  request,
  toast
} from '../../../../../../utils';
import {
  DOC_TYPE,
  EMPLOYEE_TYPE,
  GENDER_DROPDOWN,
  REG_LOCATION,
  STAFF_TYPE,
  YES_NO
} from '../../../../../../constants';
import { CustomButtonn } from '../../../../../../components';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../../../../../../utils';

const TABLE_COLUMNS = [
  {
    header: 'Doctor Name',
    accessor: (row) => {
      const status = row.status;
      return (
        <span
          style={{
            color: status === 'inactive' ? 'red' : 'black'
          }}
        >
          {`${row.name}`}
        </span>
      );
    }
  },
  {
    header: 'Doctor Type',
    accessor: 'type'
  },
  {
    header: 'Gender',
    accessor: 'gender'
  },
  {
    header: 'Department',
    accessor: 'qualification_details.department.department'
  },
  {
    header: 'Speciality',
    accessor: 'qualification_details.speciality.speciality'
  },
  {
    header: 'Location',
    accessor: 'other_details.location'
  },
  {
    header: 'Status',
    accessor: 'status',
    sx: { textTransform: 'uppercase' }
  },
  {
    header: 'Created At',
    accessor: 'createdAt'
  }
];

const initialDoctorDataObj = {
  data: [],
  loading: false
};

export const DoctorMaster = () => {
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [doctorDataObj, setDoctorDataObj] = useState(initialDoctorDataObj);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [doctorUnitDropdown, setDoctorUnitDropdown] = useState([]);
  const [specialityDropdown, setSpecialityDropdown] = useState([]);
  const [departmentDropdown, setDepartmentDropdown] = useState([]);
  const [feeGroupDropdown, setFeeGroupDropDown] = useState([]);
  const [input, setInput] = useState('');
  const [originalData, setOriginalData] = useState([]);
  const [isFiltered, setIsFiltered] = useState(false);
  // --- Doctor login provisioning ---
  const [openLoginDialog, setOpenLoginDialog] = useState(false);
  const [loginForm, setLoginForm] = useState({ username: '', password: '' });
  const [loginStatus, setLoginStatus] = useState({ hasLogin: false });
  const [loginLoading, setLoginLoading] = useState(false);
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const user = localStorage.getItem("user");
  const userDetail = JSON.parse(user)

  const fieldOneRef = useRef(null);
  const fieldTwoRef = useRef(null);
  const fieldThreeRef = useRef(null);
  const fieldFourRef = useRef(null);
  const fieldFiveRef = useRef(null);
  const fieldSixRef = useRef(null);
  const fieldSevenRef = useRef(null);
  const fieldEightRef = useRef(null);
  const fieldNineRef = useRef(null);
  const fieldTenRef = useRef(null);
  const fieldElevenRef = useRef(null);

  const handleKeyPress = (e, nextFieldRef) => {
    if (e.key === 'Tab' && nextFieldRef) {
      e.preventDefault();
      nextFieldRef.current.focus();
    }
  };

  const getDoctorUnitDropdown = useCallback(async () => {
    const data = await dropdownFetch('doctor-unit');
    setDoctorUnitDropdown(data);
  }, []);
  const getSpecialityDropdown = useCallback(async () => {
    const data = await dropdownFetch('speciality-master');
    setSpecialityDropdown(data);
  }, []);
  const getDepartmentDropdown = useCallback(async () => {
    const data = await dropdownFetch('department');
    setDepartmentDropdown(data);
  }, []);
  const getFeeGroupDropdown = useCallback(async () => {
    const data = await dropdownFetch('feegroup-master');
    setFeeGroupDropDown(data);
  }, []);
  useEffect(() => {
    getDoctorUnitDropdown();
    getSpecialityDropdown();
    getDepartmentDropdown();
    getFeeGroupDropdown();
  }, [getDoctorUnitDropdown, getSpecialityDropdown, getDepartmentDropdown, getFeeGroupDropdown]);

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        name: Yup.string().required(' '),
        staff_type: Yup.string().required(' '),
        type: Yup.string().required(' '),
        gender: Yup.string().required(' '),
        license_no: Yup.string().required(' '),
        mobile_no: Yup.string().required(' '),
        qualification_details: Yup.object().shape({
          qualification_1: Yup.string().required(' '),
          department: Yup.string().required(' ')
        }),
        other_details: Yup.object().shape({
          shift: Yup.string().required(' '),
          location: Yup.string().required(' '),
          feegroup: Yup.string().required(' ')
        })
      })
    ),
    defaultValues: {
      doctor_unit: null,
      address: { country: 'IN' },
      qualification_details: {
        speciality: null
      },
      other_details: {
        ot_doctor: 'No',
        opd_allowed: 'No'
      }
    },
    mode: 'all'
  });
  const { handleSubmit, setValue, reset, watch } = methods;

  useEffect(() => {
    if (selectedRecord) {
      const keyValuePair = getKeyPathValue(selectedRecord, '', ['_id', 'status', '__v']);
      keyValuePair.forEach(({ key, value }) => setValue(key, value));
    } else {
      reset();
    }
  }, [setValue, reset, selectedRecord]);

  const formSubmit = async (formValues) => {
    setLoading(true);
    let editFlag = false;
    if (currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/doctor-update' : '/doctor-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: { ...formValues, status: formValues.default ? 'default' : 'active' }
    });
    if (response?.success) {
      console.log(response.data);
      try {
        const message = `Hello Doctor ${response?.data?.name} 👋,
Have a Nice Day🌹
I'm your SARS HMS working at  ${userDetail.nameOfOrg},
I'm the best Web based software,
You may enjoy with my best services,
I'm  just away a call/msg  @9215616062 "with attractive gifts"
Regards,
Sonu Kashyap
CEO SARS ERP Solution Pvt Ltd`;
        const responsee = axios.post(`${BASE_URL}/proxy/send`, {
          number: `${response?.data?.mobile_no}`,
          type: 'text',
          message: encodeURIComponent(message)
        });
      } catch (error) {
        console.log(error);
      }
      toast(`Successfully ${editFlag ? 'edited' : 'created'} Doctor master`, { variant: 'success' });
      setSelectedRecord(response?.data);
      setCurrentAction();
    } else {
      toast(`Failed to ${editFlag ? 'edit' : 'create'} Doctor master`, { variant: 'error' });
    }
    setLoading(false);
  };

  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/doctor-cancel', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully Cancelled Doctor master', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to Cancelled Doctor master', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/doctor-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Doctor master', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete Doctor master', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setDoctorDataObj({ loading: true });
    const response = await request('/doctor-list', { method: 'GET' });
    if (response.success) {
      const filteredData = response.data.filter(
        (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setDoctorDataObj({ loading: false, data: filteredData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setDoctorDataObj({ loading: false });
    }
  };

  useEffect(() => {
    if (doctorDataObj.data && doctorDataObj.data.length > 0) {
      setOriginalData(doctorDataObj.data);
      setIsFiltered(false);
    }
  }, [doctorDataObj.data]);

  useEffect(() => {
    handleDoctorSearch();
  }, [input]);

  const handleDoctorSearch = async () => {
    const lowercasedInput = input.toLowerCase().trim();

    try {
      const response = await request('/doctor-list', {
        method: 'GET',
        query: { uhid: lowercasedInput, name: lowercasedInput }
      });
      if (response.success && Array.isArray(response.data)) {
        setDoctorDataObj({ loading: false, data: response.data });
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setDoctorDataObj({ loading: false, data: [] });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
      setDoctorDataObj({ loading: false, data: [] });
    }
  };

  const handleChange = (e) => {
    const newInput = e.target.value;
    setInput(newInput);
  };

  const handleOpenLoginDialog = async () => {
    if (!selectedRecord?._id) return;
    setOpenLoginDialog(true);
    setLoginForm({ username: '', password: '' });
    setLoginStatus({ hasLogin: false });
    const response = await request(`/doctor/${selectedRecord._id}/login-status`, { method: 'GET' }, true);
    if (response?.success && response.data) {
      setLoginStatus(response.data);
      if (response.data.hasLogin) {
        setLoginForm((prev) => ({ ...prev, username: response.data.username || '' }));
      }
    }
  };

  const handleSubmitLogin = async () => {
    if (!loginForm.username?.trim() || !loginForm.password?.trim()) {
      toast('Username and password are required', { variant: 'error' });
      return;
    }
    setLoginLoading(true);
    const response = await request(
      `/doctor/${selectedRecord._id}/login`,
      { method: 'POST', body: { username: loginForm.username.trim(), password: loginForm.password } },
      true
    );
    if (response?.success) {
      toast(response.message || 'Doctor login saved', { variant: 'success' });
      setOpenLoginDialog(false);
      setLoginForm({ username: '', password: '' });
    } else {
      toast(response?.message || 'Failed to save doctor login', { variant: 'error' });
    }
    setLoginLoading(false);
  };

  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: '100vw',
            boxSizing: 'border-box',
            minWidth: '100%'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Doctor Master
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                    reset();
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <Button
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction)}
                  onClick={handleOpenLoginDialog}
                >
                  Doctor Login
                </Button>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '100%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                  <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem', fontSize: '1.4rem' }}>
                    Staff Type
                  </Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                    menus={STAFF_TYPE}
                    name="staff_type"
                    inputRef={fieldOneRef}
                    onKeyDown={(e) => handleKeyPress(e, fieldTwoRef)}
                  />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                  <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem' }}>Type</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                    name="type"
                    menus={EMPLOYEE_TYPE}
                    inputRef={fieldTwoRef}
                    onKeyDown={(e) => handleKeyPress(e, fieldThreeRef)}
                  />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                  <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem' }}>Name</Typography>
                  <TextField
                    sx={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                    name="name"
                    placeholder="Name"
                    inputRef={fieldThreeRef}
                    disabled={!['new', 'edit'].includes(currentAction)}
                    onKeyDown={(e) => handleKeyPress(e, fieldFourRef)}
                  />
                </Stack>
              </Stack>

              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                  <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem' }}>Code/Alias</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.8 }}
                    name="code_alias"
                    placeholder="Code Alias"
                  />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                  <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem' }}>Gender</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                    name="gender"
                    menus={GENDER_DROPDOWN}
                    inputRef={fieldFourRef}
                    onKeyDown={(e) => handleKeyPress(e, fieldFiveRef)}
                  />
                </Stack>

                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                  <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem' }}>Mobile</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                    name="mobile_no"
                    placeholder="Mobile No"
                    inputRef={fieldFiveRef}
                    onKeyDown={(e) => handleKeyPress(e, fieldSixRef)}
                  />
                </Stack>
              </Stack>

              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                  <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem' }}>Country</Typography>
                  <SelectTag
                    formControlSX={{ flex: 0.8 }}
                    menus={[{ _id: 'IN', name: 'India' }]}
                    disabled={true}
                    name="address.country"
                  />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                  <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem' }}>State</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.8 }}
                    name="address.state"
                    menus={getStatesByCountry(watch('address.country'))}
                  />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                  <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem' }}>City</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.8 }}
                    name="address.city"
                    menus={getCityByState(watch('address.country'), watch('address.state'))}
                  />
                </Stack>
              </Stack>

              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                  <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem' }}>Town</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.8 }}
                    name="address.town"
                    placeholder="Town"
                  />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                  <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem' }}>Address 1</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.8 }}
                    name="address.line[0]"
                    placeholder="Address 1"
                  />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                  <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem' }}>Address 2</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.8 }}
                    name="address.line[1]"
                    placeholder="Address 2"
                  />
                </Stack>
              </Stack>

              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                  <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem' }}>Reg. No.</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.8 }}
                    name="reg_no"
                    placeholder="Registeration No."
                  />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                  <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem' }}>License No.</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                    name="license_no"
                    placeholder="License No"
                    inputRef={fieldSixRef}
                    onKeyDown={(e) => handleKeyPress(e, fieldSevenRef)}
                  />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                  <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem' }}>Unit</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.8 }}
                    name="doctor_unit"
                    menus={doctorUnitDropdown.map((data) => ({ ...data, name: data.unit }))}
                  />
                </Stack>
              </Stack>
              <Stack direction="row" spacing={2} alignItems="center">
                <Typography sx={{ flex: 0.06, fontSize: '1.4rem', fontWeight: 700 }}>Default</Typography>
                <Checkbox
                  disabled={!['new', 'edit'].includes(currentAction)}
                  name="default"
                  {...methods.register('default')}
                />
              </Stack>
              <Grid container spacing={1}>
                <Grid item xs={12} sx={{ mt: 1 }}>
                  <Typography variant="h5" fontWeight="bold">
                    Qualification Details
                  </Typography>
                  <Divider />
                </Grid>
                <Stack sx={{ mb: 0.3, width: '100%' }} direction="row" spacing={2}>
                  <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Qual. 1</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                      name="qualification_details.qualification_1"
                      placeholder="Qualification 1"
                      inputRef={fieldSevenRef}
                      onKeyDown={(e) => handleKeyPress(e, fieldEightRef)}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Qual. 2</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8 }}
                      name="qualification_details.qualification_2"
                      placeholder="Qualification 2"
                    />
                  </Stack>
                  <Stack spacing={0.2} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Department</Typography>
                    <SelectTag
                      disabled={!['new', 'edit'].includes(currentAction)}
                      formControlSX={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                      name="qualification_details.department"
                      menus={departmentDropdown.map((data) => ({ ...data, name: data.department }))}
                      inputRef={fieldEightRef}
                      onKeyDown={(e) => handleKeyPress(e, fieldNineRef)}
                    />
                  </Stack>
                </Stack>
                <Stack sx={{ mb: 0.3, width: '100%' }} direction="row" spacing={2}>
                  <Stack spacing={0.2} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Speciality</Typography>
                    <SelectTag
                      disabled={!['new', 'edit'].includes(currentAction)}
                      formControlSX={{ flex: 0.8 }}
                      name="qualification_details.speciality"
                      menus={specialityDropdown.map((data) => ({ ...data, name: data.speciality }))}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Designation</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8 }}
                      name="qualification_details.designation"
                      placeholder="Designation"
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Job Exp.</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8 }}
                      name="qualification_details.job_exp"
                      placeholder="Job Experience"
                    />
                  </Stack>
                </Stack>

                <Grid item xs={12} sx={{ mt: 1 }}>
                  <Typography variant="h5" fontWeight="bold">
                    Other Details
                  </Typography>
                  <Divider />
                </Grid>
                <Stack sx={{ mb: 0.3, width: '100%' }} direction="row" spacing={2}>
                  <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Shift</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                      name="other_details.shift"
                      placeholder="Shift"
                      inputRef={fieldNineRef}
                      onKeyDown={(e) => handleKeyPress(e, fieldTenRef)}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Location</Typography>
                    <SelectTag
                      disabled={!['new', 'edit'].includes(currentAction)}
                      formControlSX={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                      name="other_details.location"
                      menus={REG_LOCATION}
                      inputRef={fieldTenRef}
                      onKeyDown={(e) => handleKeyPress(e, fieldElevenRef)}
                    />
                  </Stack>

                  <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>OPD</Typography>
                    <SelectTag
                      formControlSX={{ flex: 0.8 }}
                      disabled={!['new', 'edit'].includes(currentAction)}
                      name="other_details.opd_allowed"
                      menus={YES_NO}
                    />
                  </Stack>
                </Stack>

                <Stack sx={{ mb: 0.3, width: '100%' }} direction="row" spacing={2}>
                  <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                    <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>OPD Room/Floor</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.2 }}
                      name="other_details.opd_room"
                      placeholder="Room"
                      type="number"
                    />
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.2 }}
                      name="other_details.opd_floor"
                      placeholder="Floor"
                      type="number"
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Fee Group</Typography>
                    <SelectTag
                      disabled={!['new', 'edit'].includes(currentAction)}
                      formControlSX={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                      name="other_details.feegroup"
                      menus={feeGroupDropdown.map((data) => ({ ...data, name: data.feegroup }))}
                      inputRef={fieldElevenRef}
                      onKeyDown={(e) => handleKeyPress(e, fieldOneRef)}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                    <Typography sx={{ flex: 0.5, fontWeight: 700, fontSize: '1.4rem' }}>
                      Re Visit / Free Revisits
                    </Typography>
                    <TextField
                      sx={{ flex: 0.25 }}
                      disabled={!['new', 'edit'].includes(currentAction)}
                      type="number"
                      name="other_details.re_visit_validity"
                    />
                    <TextField
                      sx={{ flex: 0.25 }}
                      disabled={!['new', 'edit'].includes(currentAction)}
                      type="number"
                      name="other_details.free_revisits"
                    />
                  </Stack>
                </Stack>
                <Stack sx={{ mb: 0.3, width: '100%' }} direction="row" spacing={2}>
                  <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                    <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>
                      OT Doctor/Booking Limit
                    </Typography>
                    <SelectTag
                      disabled={!['new', 'edit'].includes(currentAction)}
                      formControlSX={{ flex: 0.3 }}
                      onChange={() => setValue('other_details.doctype', '')}
                      name="other_details.ot_doctor"
                      menus={YES_NO}
                    />
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.2 }}
                      name="other_details.ot_booking_limit"
                      type="number"
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Doc Type</Typography>
                    <SelectTag
                      disabled={
                        methods.watch('other_details.ot_doctor') !== 'Yes' || !['new', 'edit'].includes(currentAction)
                      }
                      formControlSX={{ flex: 0.8 }}
                      name="other_details.doctype"
                      menus={DOC_TYPE}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Heading 1</Typography>
                    <TextField
                      sx={{ flex: 0.8 }}
                      disabled={!['new', 'edit'].includes(currentAction)}
                      name="other_details.heading[0]"
                      placeholder="Heading 1"
                    />
                  </Stack>
                </Stack>

                <Stack sx={{ mb: 0.3, width: '100%' }} direction="row" spacing={2}>
                  <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Heading 2</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8 }}
                      name="other_details.heading[1]"
                      placeholder="Heading 2"
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Heading 3</Typography>
                    <TextField
                      sx={{ flex: 0.8 }}
                      disabled={!['new', 'edit'].includes(currentAction)}
                      name="other_details.heading[2]"
                      placeholder="Heading 3"
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Heading 4</Typography>
                    <TextField
                      sx={{ flex: 0.8 }}
                      disabled={!['new', 'edit'].includes(currentAction)}
                      name="other_details.heading[3]"
                      placeholder="Heading 4"
                    />
                  </Stack>
                </Stack>

                <Stack sx={{ mb: 0.3, width: '100%' }} direction="row" spacing={2}>
                  <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Indoor Visit</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8 }}
                      name="other_details.indoor_visit"
                      placeholder="Indoor Visit"
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Consultancy</Typography>
                    <TextField
                      sx={{ flex: 0.8 }}
                      disabled={!['new', 'edit'].includes(currentAction)}
                      name="other_details.consultancy"
                      placeholder="Consultancy"
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Procedure</Typography>
                    <TextField
                      sx={{ flex: 0.8 }}
                      disabled={!['new', 'edit'].includes(currentAction)}
                      name="other_details.procedure"
                      placeholder="Procedure"
                    />
                  </Stack>
                </Stack>
                <Stack sx={{ mb: 0.3, width: '100%' }} direction="row" spacing={2}>
                  <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                    <Typography sx={{ flex: 0.19, fontWeight: 700, fontSize: '1.4rem' }}>Reference</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.78 }}
                      name="other_details.reference"
                      placeholder="Reference"
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                    <Typography sx={{ flex: 0.19, fontWeight: 700, fontSize: '1.4rem' }}>Vaccination</Typography>
                    <TextField
                      sx={{ flex: 0.78 }}
                      disabled={!['new', 'edit'].includes(currentAction)}
                      name="other_details.vaccination"
                      placeholder="Vaccination"
                    />
                  </Stack>
                </Stack>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0.2}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Doctor Master Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '14px'
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 10px'
                // fontSize: '14px'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            label="Search Doctors"
            variant="outlined"
            value={input}
            onChange={handleChange}
          />
        </Stack>
        <Table
          sx={{ mt: 1 }}
          columns={TABLE_COLUMNS}
          data={originalData || []}
          loading={originalData.loading}
          onRowClick={(row) => {
            setOpenQueryDialog(false);
            const { qualification_details, other_details, ...basic_details } = row;
            setSelectedRecord({
              ...basic_details,
              doctor_unit: basic_details.doctor_unit?._id || null,
              qualification_details: {
                ...qualification_details,
                speciality: qualification_details?.speciality?._id || null,
                department: qualification_details?.department?._id || null
              },
              other_details: { ...other_details, feegroup: other_details?.feegroup?._id || null }
            });
          }}
        />
      </Dialog>
      <Dialog
        open={openLoginDialog}
        onClose={() => setOpenLoginDialog(false)}
        PaperProps={{ sx: { width: '420px', p: 2 } }}
        maxWidth="sm"
      >
        <Stack
          padding={0.2}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            {loginStatus.hasLogin ? 'Reset Doctor Login' : 'Create Doctor Login'}
          </Typography>
          <IconButton onClick={() => setOpenLoginDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack spacing={2} sx={{ mt: 2 }}>
          <Typography variant="body2" color="text.secondary">
            {selectedRecord?.name}
            {loginStatus.hasLogin
              ? ' — a login already exists. Saving will update the username/password.'
              : ' — set the username and password this doctor will log in with.'}
          </Typography>
          <MuiTextField
            label="Username"
            variant="outlined"
            fullWidth
            value={loginForm.username}
            onChange={(e) => setLoginForm((prev) => ({ ...prev, username: e.target.value }))}
          />
          <MuiTextField
            label="Password"
            type="password"
            variant="outlined"
            fullWidth
            value={loginForm.password}
            onChange={(e) => setLoginForm((prev) => ({ ...prev, password: e.target.value }))}
          />
          <Stack direction="row" spacing={1} justifyContent="flex-end">
            <Button variant="outlined" onClick={() => setOpenLoginDialog(false)} disabled={loginLoading}>
              Cancel
            </Button>
            <Button variant="contained" onClick={handleSubmitLogin} disabled={loginLoading}>
              {loginStatus.hasLogin ? 'Update Login' : 'Create Login'}
            </Button>
          </Stack>
        </Stack>
      </Dialog>
    </>
  );
};
